/**
 * Componente de Barra de Pesquisa
 */

import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import theme from '@theme';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  onKeyPress?: (event: React.KeyboardEvent) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Pesquisar...',
  fullWidth = true,
  disabled = false,
  onKeyPress,
}) => {
  return (
    <TextField
      fullWidth={fullWidth}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      variant="outlined"
      size="small"
      sx={{ bgcolor: theme.palette.elite.contrastText }}
    />
  );
};
